<template>
	<div>
		<div class="white-bg">
			<div class="content tsfx">
				<div class="title u-text-center">探索发现</div>
				<div class=" u-text-center title_tips">中国经典文化IP元素一网打尽</div>
				<div class="tsfx-b">
					<div class="tsfx-c" @click="toDetails(item)" :class="{tsfxCB:index<4}" v-for="(item,index) in list"
						:key="index">
						<div class="s_list_img ">
							<el-image class="" fit="cover" :src="item.url" />
						</div>
						<div class="tsfx_name">
							{{item.categoryName}}
						</div>
					</div>
				</div>
			</div>
			<br>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'personetails',
		components: {},
		data() {
			return {
				list: []
			};
		},
		created() {
			this.getlist()
		},
		methods: {
			async getlist() {
				const res = await this.$axios.get('/front/listCategory', {
					level: 2
				})
				let data = res.data.slice(0, 8)
				this.list = data
				this.adImg()
			},
			toDetails(item) {
				const {
					href
				} = this.$router.resolve({
					name: 'discovery',
					params: {
						categoryId: item.categoryId,
						parentId: item.parentId,
						type: 'dis'
					}
				})
				window.open(href, '_blank')
			},
			async adImg() {
				const res = await this.$axios.get('/front/getAdvertisingByLocation', {
					advertisingLocation: 'index-category'
				})
				res.data.forEach((item, index) => {
					this.list.forEach((items, indexs) => {
						if (index == indexs) {
							this.list[index].url = item.advertisingImage
						}
					})
				})
				this.$forceUpdate()
			}
		}
	}
</script>
<style lang="scss" scoped>
	//探索发现
	.tsfx {
		padding: 100px 0 80px 0;

		.tsfx-b {
			overflow: hidden;
			cursor: pointer;
			margin-top: 60px;

			.tsfx-c {
				border-radius: 10px;
				width: 23.5%;
				overflow: hidden;
				float: left;
				margin-right: 2%;
				background-color: var(--white);
				position: relative;

				.s_list_img .el-image {
					height: 300px;
				}

				.tsfx_name {
					position: absolute;
					bottom: -54px;
					height: 24px;
					padding: 14px 0;
					font-size: 16px;
					background-image: linear-gradient(rgba(0, 0, 0, .2), rgba(0, 0, 0, 1));
					color: var(--white);
					width: 100%;
					transition-duration: .4s;
					text-align: center;
				}

				&:hover .tsfx_name {
					bottom: 0px;
				}
			}

			.tsfx-c:nth-child(4n) {
				margin-right: 0;
			}
		}

		.tsfxCB {
			margin-bottom: 2%;
		}
	}
</style>
